<mat-dialog-content class="dialog-content">
    <img [src]="data.imageUrl" alt="Imagem Ampliada" class="full-image">
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Fechar</button>
  </mat-dialog-actions>
  